<template>
  <div class="homepage-container homepage-v1">
    <!-- Split Hero Section -->
    <section class="split-hero">
      <div class="container-fluid p-0">
        <div class="row g-0 align-items-stretch">
          <!-- Left Content -->
          <div class="col-lg-6 d-flex align-items-center bg-white hero-content-col">
            <div class="hero-left-content animate-fade-in">
              <h1 class="promo-title" v-html="$t('Home.V1BannerTitle')"></h1>
              <p class="promo-desc" v-html="$t('Home.V1BannerDesc')"></p>
              
              <div class="btn-container">
                <router-link to="/SignIn" class="btn btn-get-started">
                  {{ $t('Home.GetStartedBtn') }}
                </router-link>
              </div>
              
              <p class="btn-subtext">{{ $t('Home.ReadyToSubmitDesc') }}</p>
              
              <div class="hero-links">
                <a href="#" class="accent-link d-block mb-1">{{ $t('Header.ClaimOfferTab') }}</a>
                <div class="faq-link-item">
                  {{ $t('Home.TroubleParticipating') }} <router-link to="/FAQ" class="accent-link">{{ $t('Home.FAQsText') }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- Right Banner Image -->
          <div class="col-lg-6 hero-slider-col position-relative">
            <img src="/assets/images/offer-wall-banner.png" class="hero-banner-img" alt="Offer Wall Banner" />
          </div>
        </div>
      </div>
    </section>

    <!-- How to Participate Section -->
    <section class="how-to-participate-section" :style="{ '--htw-bg-desktop': 'url(' + $t('Home.HtwBgDesktop') + ')', '--htw-bg-mobile': 'url(' + $t('Home.HtwBgMobile') + ')' }">
      <div class="container">
        <h2 class="section-title text-center animate-fade-in">{{ $t('Home.HtwTitleDesktop') }}</h2>
        
        <div class="row justify-content-center htw-cards-grid">
          <!-- Card 1 -->
          <div class="col-md-6 mb-4 animate-card-1">
            <div class="htw-card">
              <div class="card-header-row">
                <span class="card-num">01</span>
                <div class="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shopping-cart"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                </div>
              </div>
              <h3 class="card-title">{{ $t('Home.HtwV1Step1Title') }}</h3>
              <p class="card-desc">{{ $t('Home.HtwV1Step1Desc') }}</p>
            </div>
          </div>

          <!-- Card 2 -->
          <div class="col-md-6 mb-4 animate-card-2">
            <div class="htw-card">
              <div class="card-header-row">
                <span class="card-num">02</span>
                <div class="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-camera"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                </div>
              </div>
              <h3 class="card-title">{{ $t('Home.HtwV1Step2Title') }}</h3>
              <p class="card-desc">{{ $t('Home.HtwV1Step2Desc') }}</p>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="col-md-6 mb-4 animate-card-3">
            <div class="htw-card">
              <div class="card-header-row">
                <span class="card-num">03</span>
                <div class="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                </div>
              </div>
              <h3 class="card-title">{{ $t('Home.HtwV1Step3Title') }}</h3>
              <p class="card-desc">{{ $t('Home.HtwV1Step3Desc') }}</p>
            </div>
          </div>

          <!-- Card 4 (Active/Highlighted by default, but transitions smoothly on hover) -->
          <div class="col-md-6 mb-4 animate-card-4">
            <div class="htw-card highlighted">
              <div class="card-header-row">
                <span class="card-num">04</span>
                <div class="icon-wrapper">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2584C5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shield"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 11 11 13 15 9"></polyline></svg>
                </div>
              </div>
              <h3 class="card-title">{{ $t('Home.HtwV1Step4Title') }}</h3>
              <p class="card-desc">{{ $t('Home.HtwV1Step4Desc') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePageV1',
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
};
</script>

<style scoped>
/* Page Layout */
.homepage-container {
  overflow-x: hidden;
}

/* Split Hero Styles */
.split-hero {
}

.hero-content-col {
  padding: 2rem;
}

.hero-left-content {
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
}

.promo-title {
  font-size: 2.75rem;
  font-weight: 800;
  line-height: 1.2;
  color: #000000;
  margin-bottom: 1.5rem;
}

:deep(.text-primary) {
  color: #2584C5 !important;
}

.promo-desc {
  font-size: 1.15rem;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 2rem;
}

.btn-container {
  margin-bottom: 1rem;
}

.btn-get-started {
  display: inline-block;
  background-color: #2584C5;
  color: #ffffff !important;
  font-size: 1.15rem;
  font-weight: 600;
  padding: 0.75rem 4rem;
  border-radius: 4px;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(37, 132, 197, 0.25);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: none;
  text-align: center;
  width: 100%;
  max-width: 320px;
}

.btn-get-started:hover {
  background-color: #1b6ca2;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(37, 132, 197, 0.4);
  text-decoration: none !important;
}

.btn-get-started:active {
  transform: translateY(0);
}

.btn-subtext {
  font-size: 0.9rem;
  color: #6b7280;
  margin-bottom: 2rem;
}

.hero-links {
  margin-top: 1.5rem;
  font-size: 0.95rem;
}

.accent-link {
  color: #2584C5 !important;
  text-decoration: underline !important;
  font-weight: 500;
}

.accent-link:hover {
  color: #1b6ca2 !important;
}

.hero-slider-col {
  min-height: 380px;
}

.hero-banner-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* How to Participate Section */
.how-to-participate-section {
  background-image: var(--htw-bg-desktop);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 6rem 0;
  position: relative;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4rem;
}

.htw-cards-grid {
  max-width: 960px;
  margin: 0 auto;
}

/* Glassmorphism Cards */
.htw-card {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  padding: 2.5rem;
  color: #ffffff;
  min-height: 250px;
  backdrop-filter: blur(12px);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  display: flex;
  flex-direction: column;
}

.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.card-num {
  font-size: 2rem;
  font-weight: 600;
  opacity: 0.6;
  font-family: 'Outfit', 'Inter', sans-serif;
  transition: all 0.3s ease;
}

.icon-wrapper {
  background: #ffffff;
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.card-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #ffffff;
  transition: all 0.3s ease;
}

.card-desc {
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
  transition: all 0.3s ease;
}

/* Card Active/Hover states */
.htw-card:hover, .htw-card.highlighted {
  background: #ffffff;
  border-color: #ffffff;
  color: #000000;
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.htw-card:hover .card-num, .htw-card.highlighted .card-num {
  color: #4b5563;
  opacity: 0.7;
}

.htw-card:hover .card-title, .htw-card.highlighted .card-title {
  color: #000000;
}

.htw-card:hover .card-desc, .htw-card.highlighted .card-desc {
  color: #4b5563;
}

.htw-card:hover .icon-wrapper, .htw-card.highlighted .icon-wrapper {
  background: rgba(37, 132, 197, 0.1);
}

/* SEO Copy Styles */
.seo-headline {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  max-width: 800px;
  margin: 0 auto;
}

.seo-desc {
  font-size: 1rem;
  color: #4b5563;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.7;
}

.abbrv-terms {
  font-size: 0.8rem;
  max-width: 900px;
  margin: 0 auto;
  line-height: 1.6;
}

/* Animations */
.animate-fade-in {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
}

.animate-card-1 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.2s;
}

.animate-card-2 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.4s;
}

.animate-card-3 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.6s;
}

.animate-card-4 {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeIn 0.8s cubic-bezier(0.25, 0.8, 0.25, 1) forwards;
  animation-delay: 0.8s;
}

@keyframes fadeIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive styles */
@media screen and (max-width: 1199px) {
  .promo-title {
    font-size: 2.25rem;
  }
  .hero-content-col {
    padding: 3rem 2rem;
  }
}

@media screen and (max-width: 991px) {
  .hero-content-col {
    padding: 3.5rem 1.5rem;
  }
  .hero-slider-col {
    min-height: 400px;
  }
  .how-to-participate-section {
    padding: 4.5rem 0;
  }
  .section-title {
    font-size: 2rem;
    margin-bottom: 3rem;
  }
}

@media screen and (max-width: 767px) {
  .promo-title {
    font-size: 1.85rem;
  }
  .hero-left-content {
    text-align: center;
  }
  .btn-get-started {
    max-width: 100%;
  }
  .hero-slider-col {
    min-height: 300px;
  }
  .how-to-participate-section {
    background-image: var(--htw-bg-mobile);
    padding: 3.5rem 0;
  }
  .section-title {
    font-size: 1.75rem;
    margin-bottom: 2.5rem;
  }
  .htw-card {
    padding: 2rem;
    min-height: auto;
  }
  .seo-headline {
    font-size: 1.6rem;
  }
}
</style>
